export enum AutocompleteTagsEnum {
  TAGS = 'tags',
}
